export default "__VITE_ASSET__DtDE1TVO__"